import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a7302718295d5001438111b_1786387556826_04b571e1/awsclubportal/src/app/sign-up-login-screen/components/AuthScreen.tsx");
